import { useEffect, useState } from 'react';
import { updateEnv, isPanelUrlIncludesEventOrigin } from '@repo/env';
// This hook is use only for tests.
// If the user wants to change the environment variables without using gitlab,
// user can define them when initializing the constructor, e.g.:
// const config = {
//   VITE_API_URL: "https://test.pl/api",
//   VITE_MAIN_APP_URL: "https://test.pl",
//   VITE_WIDGET_APP_URL: "https://test.pl",
//   VITE_PANEL_URL: "https://test.pl",
// }
// const financingApp = new FinancingApp('hash', config);
export var useSetEnvConfigFromIframe = function () {
    var _a = useState('INIT'), status = _a[0], setStatus = _a[1];
    useEffect(function () {
        setStatus('PENDING');
        window.parent.postMessage({ type: 'READY' }, '*');
    }, []);
    function setEnvConfigFromIframe(evt) {
        var _a;
        if (!isPanelUrlIncludesEventOrigin(evt.origin)) {
            setStatus('FINISH');
            console.warn('Event URL does not exist in testing white list');
            return;
        }
        else if (typeof ((_a = evt.data) === null || _a === void 0 ? void 0 : _a.envConfig) === 'object') {
            setStatus('FINISH');
            updateEnv(evt.data.envConfig);
        }
        else {
            setStatus('FINISH');
            console.warn('no envConfig found for this URL');
            return;
        }
    }
    useEffect(function () {
        setStatus('PENDING');
        window.addEventListener('message', function (evt) {
            setEnvConfigFromIframe(evt);
        }, false);
        return function () {
            window.removeEventListener('message', setEnvConfigFromIframe);
        };
    }, []);
    return { status: status };
};
